<template>
  <div class="application" :style="{'paddingTop': statusBar + 'rem'}">
    <Header :title="'推荐'+info" :back="true" left="返回" :white="true"/>
    <div class="applicationmain">
      <div class="main">
        <div class="top">
          <img :src="appInfo.appIcon" alt="">
          {{appInfo.appName}}
        </div>
        <div class="time"><p>发布日期：{{appInfo.appReleaseTime}}</p></div>
        <div class="info">
          <div class="info_div">
          <p class="p_top">版本号<span>{{appInfo.appVersion}}</span></p>
          </div>
          <div class="info_div">
          <p class="p_top">服务分类<span>{{appInfo.appBiztypeName}}</span></p>
          </div>
          <!-- <p>使用次数<span>12345人次</span></p> -->
        </div>
      </div>
      <div class="describe">
        <p class="title">服务简介</p>
        <div class="desc" v-html="appInfo.appDetailsIntroduce"></div>
        <p></p>
      </div>
      <div class="describe">
        <p class="title">更新说明</p>
        <div class="desc1"  v-html="appInfo.appUpdateDetail"></div>
        <!-- <p class="desc1">2.  V1.0发布说明发布说明</p>
        <p class="desc1">3.  V1.0发布说明发布说明</p>
        <p class="desc1">4.  V1.0发布说明发布说明</p> -->
      </div>
      <div  class="popup" >
        <div v-if="flag==='0'" class="btn btn1" @click="addto()">添加到我的</div>
        <div v-if="flag==='1'" class="btn btn2" aria-readonly="true">已添加到我的</div>
        <div class="btn btn3" @click="goto()">进入</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'application',
  /**
   * 初始化数据
   */
  data() {
    return {
      backormoren: true,
      appInfo: {},
      statusBar: 0,
      flag:`${this.$route.params.flag}`,
      // flag:"1",
      // info:"最新",
      info: `${this.$route.params.info}`,
      appUrl: `${window.location.origin}`+"/"+`${this.$route.params.appPath}`,
      appid : `${this.$route.params.appid}`,
    }
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  //   this.getAppliDetails();
    if(this.$route.params.appid){
        this.getAppliDetails();
    }else{
       this.appInfo = JSON.parse(localStorage.getItem('application_appinfo'))
       this.info=JSON.parse(localStorage.getItem('application_info'))
       this.appUrl=JSON.parse(localStorage.getItem('application_appUrl'))
       this.flag=JSON.parse(localStorage.getItem('application_appFlag'))
    }
  },
  /**
   * 方法
   */
  methods: {
    /**
     * 添加至我的
     */
    addto(){
      this.backormoren = false;
        window.console.log(this.appid+"appid1")
       if(this.appid == "undefined" || this.appid ==undefined){
          this.appid = JSON.parse(localStorage.getItem('application_appid'))
           window.console.log(this.appid+"appid2")
       }
        
      this.$http.post('/zsdyckserver/app/addOneMyApp?appId='+this.appid).then(res => {
        this.$dialog.alert({
          message: res.failInfo
        }).then(() => {
          
        });
        if("1"==res.resultFlag){
          this.flag = '1'
     //     this.goBackFlag = !this.goBackFlag
          this.$store.commit('inverseFlag');
          localStorage.setItem('application_appFlag', JSON.stringify(this.flag))
        }
      }).catch(err => {
        window.console.log(err)
      })
    },


    /**
     * 跳转小
     */
    goto(){
      this.backormoren = false;
      window.location.href = this.appUrl
      // this.$tool.sessionData('#1e3cd2', 'true');
    },

    /**
     * 获取详情
     */
    getAppliDetails(){
    // this.appInfo={"appId":"1","appName":"通关全流程状态","appBizType":"tongguan","appBiztypeName":"通关物流状态查询","appIcon":"data:image/png;base64,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","appUrl":"masserver/swapp/dist/#/dec","appProvider":null,"appVersion":"V1.0","appReleaseTime":" 2020-01-17","appUpdateDetail":"<p>1、V1.0版本新上线发布</p>","appDetailsIntroduce":"<p>通关全流程状态查询主要为企业提供货物通关物流状态全流程跟踪服务。</p>"};
    //     localStorage.setItem('application_appinfo', JSON.stringify(this.appInfo))
    //     localStorage.setItem('application_info', JSON.stringify(this.$route.params.info))
    //     localStorage.setItem('application_appUrl', JSON.stringify(this.appUrl))
    //     localStorage.setItem('application_appFlag', JSON.stringify(this.flag))

      this.$http.post('/zsdyckserver/app/getAppsInfo?appId='+`${this.$route.params.appid}`).then(res => {
        localStorage.setItem('application_appinfo', JSON.stringify(res.resultData.appInfo))
        localStorage.setItem('application_info', JSON.stringify(this.$route.params.info))
        localStorage.setItem('application_appUrl', JSON.stringify(this.appUrl))
        localStorage.setItem('application_appFlag', JSON.stringify(this.flag))

        localStorage.setItem('application_appid', `${this.$route.params.appid}`)

        this.appInfo = res.resultData.appInfo;
      }).catch(err => {
        window.console.log(err)
      })
    },
  },
  components:{
    Header,
  },
  // beforeDestroy() {
  //   if(this.backormoren){
  //     this.$tool.beforeDestroy(1);
  //   }
  // },
}
</script>

<style scoped lang="scss">
  .application{
    text-align: center;
    background: #f7f8fa;
    .applicationmain{
      overflow: auto;
      background: #fff;
      padding-bottom: 10px;
      .main{
    //    padding-top: 30px;
    //    padding-bottom: 30px;
        height: 148px;
        border-bottom: 8px solid #f7f8fa;
        font-size: 0;
        .top{
          margin-top: 20px;
          color: $fontColor;
          font-weight: 600;
          font-size:18px;
          display: flex;
          align-items: center;
          justify-content: center;
          vertical-align: middle;
          img{
            float: left;
            height: 24px;
            margin-right: 6px;
          }
        }
        .time{
          margin: 13px 112.5px 13px 108.5px;
          font-size: 12px;
          line-height: 18px;
          color: #A0A5AA;
          width:154px;
          height:14px;
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          color:rgba(160,165,170,1);
          line-height:14px;
          text-align: center;
        }
        .info{
          margin-top: 20px;
          display: flex;
          .info_div{
            width:50%;
            height: 50px;
             border-right: 1px solid $lineColor;
            &:last-child{
            border-right: 0px solid $lineColor;
            }
          }
          .p_top{
            height:18px;
            font-size:12px;
            font-family:PingFang SC;
            font-weight:400;
            color:rgba(160,165,170,1);
            line-height:18px;
            flex: 1;
          }
            span{
              display: block;
              height:18px;
              font-size:14px;
              font-family:PingFang SC;
              font-weight:400;
              color:rgba(5,15,40,1);
              line-height:18px;
              padding-top: 9px;
            }
          }
        }
      }
      .describe{
        border-bottom: 8px solid #f7f8fa;
        .title{
          text-align: left;
          font-size: 15px;
          color: $fontColor;
          background: url('../../assets/image/14.png') no-repeat left center;
          background-size: auto 15px;
          padding-left:15px;
          margin: 15px 10px;
          height:20px;
          font-family:PingFang SC;
          font-weight:600;
        }
        .desc{
          color: $fontColor;
          font-size: 14px;
          text-align: left;
          text-indent: 24px;
          line-height: 24px;
          margin: 24px;
        }
        .desc1{
          color: $fontColor;
          font-size: 14px;
          text-align: left;
          line-height: 24px;
          margin: 15px 24px 15px 25px;
        }
      }
      .popup{
        bottom: 70px;
    //    z-index: 9999;
    //    position: fixed;
        padding: 15px 0;
        display: flex;
        .close{
          height: 24px;
          padding: 0px 12px;
          img{
            margin-top: 7px;
            width: 11px;
            height: 11px;
          }
        }
        .icon{
          width: 24px;
          height: 24px;
          text-align: center;
          background: #fff;
          border-radius:2px;
          img{
            height: 14px;
            margin-top: 5px;
          }
        }
        .btn{
          width: 140px;
          height: 44px;
          border-radius:2pt;
          line-height: 44px;
          background: #ff7f00;
          text-align: center;
          color: #fff;
          font-size: 14px;
        }
        .btn1{
          margin-left: 42px;
          background: #ff7f00;
          color: #fff;
        }
        .btn2{
          margin-left: 42px;
          background: #F2E6DA;
          color: #C2BFBF;
        }
        .btn3{
          margin-left: 13.5px;
          margin-right: 39.5px;
          background: #ff7f00;
          color: #fff;
        }
      }
    }
</style>

